/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:13/02/2021
 @Time:08:49
 **/

import Vente from "../../vente_achat/model/vente";

export default class PaiementLigneBase{

    /**
     * Dernier id temporaire affecté a une ligne de paiement
     * @type {number}
     * @private
     */
    static #_lastTemporaireIdGenere=0;


    /**
     * @type {string} id de ligne de paiement
     */
    #_id;

    /**
     * indique que la ligne est temporaire c'est a dire n'est pas sauvegardé coté BD
     * @type{boolean}
     */
    #_temporaire=true;

    /**
     * date de paiement de la tranche
     * @type{Date}
     */
    #_datePaiement;

    /**
     * Le montant de tranche de paiement
     * @type{number}
     */
    #_montant=0;

    /**
     * date ou la tranche a été payée
     * @type{Date}
     */
    #_payeeLe;


    #_status;

    /**
     * @type{string} le discriminateur utilisé coté java (hibernate) pour l'héritage avec liste abstraite
     */
    #_discriminator;

    /**
     * @type{Vente}
     */
    #_vente;


    get id() {
        return this.#_id;
    }

    set id(value) {
        this.#_id = value;
    }

    get datePaiement() {
        return this.#_datePaiement;
    }

    set datePaiement(value) {
        this.#_datePaiement = value;
    }

    get payeeLe() {
        return this.#_payeeLe;
    }

    set payeeLe(value) {
        this.#_payeeLe = value;
    }

    get status() {
        return this.#_status;
    }

    set status(value) {
        this.#_status = value;
    }

    get discriminator() {
        return this.#_discriminator;
    }

    set discriminator(value) {
        this.#_discriminator = value;
    }

    get vente() {
        return this.#_vente;
    }

    set vente(value) {
        this.#_vente = value;
    }


    get temporaire() {
        return this.#_temporaire;
    }

    set temporaire(value) {
        this.#_temporaire = value;
    }


    get montant() {
        return this.#_montant;
    }

    set montant(value) {
        this.#_montant = value;
    }

    /**
     * Générer un nouveau id temporaire
     * @return {string}
     */
    static generateTemporaireID(){
        let idTemporaire="tranche-paiement-ligne-temporaire-"+PaiementLigneBase.#_lastTemporaireIdGenere;
        PaiementLigneBase.#_lastTemporaireIdGenere++;
        return idTemporaire;
    }

    /**
     * retourne url de suppression d'une tranche de paiement
     * @return {string}
     */
    getURLSuppression(){
        return this.temporaire?null:Begro.getURL("paiement/"+this.id+"/supprimer");
    }

    /**
     * créer une nouvelle instance depuis un objet json
     * @param {{}} paiementLigneJson paiement ligne objet json récupéré coté serveur
     * @param {PaiementLigneBase} paiementLigneBase
     */
    static createFromJson(paiementLigneJson,paiementLigneBase)
    {
        if(paiementLigneJson.id!=null)
        {
            paiementLigneBase.id=paiementLigneJson.id;
            paiementLigneBase.temporaire=false;
        }else{
            paiementLigneBase.id=PaiementLigneBase.generateTemporaireID();

        }
        paiementLigneJson.montant||(paiementLigneBase.montant=paiementLigneJson.montant);
        paiementLigneJson.datePaiement||(paiementLigneBase.datePaiement=Date.parse(paiementLigneJson.datePaiement));
        paiementLigneJson.payeeLe||(paiementLigneBase.payeeLe=Date.parse(paiementLigneJson.payeeLe));
        paiementLigneJson.status||(paiementLigneBase.status=paiementLigneJson.status);
        return paiementLigneBase;

    }

}